import React from 'react';
import './StyledInput.css';

const StyledTextarea = ({ 
  value, 
  onChange, 
  label, 
  placeholder, 
  rows = 3,
  icon,
  variant = 'default'
}) => {
  const getIcon = () => {
    if (icon) return icon;
    
    switch (variant) {
      case 'objective':
        return '🎯';
      case 'ideas':
        return '💡';
      default:
        return null;
    }
  };

  const inputIcon = getIcon();

  return (
    <div className={`styled-input-wrapper ${variant}`}>
      <label className="styled-input-label">{label}</label>
      <div className="styled-textarea-container">
        {inputIcon && (
          <div className="styled-input-icon">
            {inputIcon}
          </div>
        )}
        <textarea
          className="styled-textarea"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={rows}
        />
      </div>
    </div>
  );
};

export default StyledTextarea;

